import { z } from "zod";


export const ProjetoRevisaoCadastroSchema = z.object({
  idProjetoRevisao: z.number().optional(),
  idProjeto: z.coerce.number(),
  idCentroCusto: z.coerce.number(),
  idFuncionarioSolicitante: z.coerce.number(),

  projeto: z.string().optional(),
  dataSolicitacao: z.coerce.date().optional(),
  observacoesSolicitacao: z.string().optional(),
  solicitante: z.string().optional(),
  idFuncionarioAprovacao: z.coerce.number().optional(),
  aprovador: z.string().optional(),
  dataAprovacao: z.coerce.date().optional().nullable(),
  dataTermino: z.coerce.date().optional().nullable(),
  status: z.coerce.number().optional(),

  arquivo1: z.instanceof(File).nullable().default(null),
  nomeArquivo1: z.string().nullable().optional(),
  arquivo2: z.instanceof(File).nullable().default(null),
  nomeArquivo2: z.string().nullable().optional(),

  limparArquivo1: z.boolean().optional(),
  limparArquivo2: z.boolean().optional(),

  observacoesAprovacao: z.string().optional(),
  disciplinasIds: z.array(z.number()).optional(),

});

export type ProjetoRevisaoCadastroForm = z.infer<typeof ProjetoRevisaoCadastroSchema>;


export const defaultProjetoRevisaoCadastroForm: Partial<ProjetoRevisaoCadastroForm> = {


}
